/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var lang_1 = require('../facade/lang');
var collection_1 = require('../facade/collection');
var EventListener = (function() {
  function EventListener(name, callback) {
    this.name = name;
    this.callback = callback;
  }
  ;
  return EventListener;
}());
exports.EventListener = EventListener;
var DebugNode = (function() {
  function DebugNode(nativeNode, parent, _debugInfo) {
    this._debugInfo = _debugInfo;
    this.nativeNode = nativeNode;
    if (lang_1.isPresent(parent) && parent instanceof DebugElement) {
      parent.addChild(this);
    } else {
      this.parent = null;
    }
    this.listeners = [];
  }
  Object.defineProperty(DebugNode.prototype, "injector", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.injector : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugNode.prototype, "componentInstance", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.component : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugNode.prototype, "context", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.context : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugNode.prototype, "references", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.references : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugNode.prototype, "providerTokens", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.providerTokens : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DebugNode.prototype, "source", {
    get: function() {
      return lang_1.isPresent(this._debugInfo) ? this._debugInfo.source : null;
    },
    enumerable: true,
    configurable: true
  });
  DebugNode.prototype.inject = function(token) {
    return this.injector.get(token);
  };
  return DebugNode;
}());
exports.DebugNode = DebugNode;
var DebugElement = (function(_super) {
  __extends(DebugElement, _super);
  function DebugElement(nativeNode, parent, _debugInfo) {
    _super.call(this, nativeNode, parent, _debugInfo);
    this.properties = {};
    this.attributes = {};
    this.childNodes = [];
    this.nativeElement = nativeNode;
  }
  DebugElement.prototype.addChild = function(child) {
    if (lang_1.isPresent(child)) {
      this.childNodes.push(child);
      child.parent = this;
    }
  };
  DebugElement.prototype.removeChild = function(child) {
    var childIndex = this.childNodes.indexOf(child);
    if (childIndex !== -1) {
      child.parent = null;
      this.childNodes.splice(childIndex, 1);
    }
  };
  DebugElement.prototype.insertChildrenAfter = function(child, newChildren) {
    var siblingIndex = this.childNodes.indexOf(child);
    if (siblingIndex !== -1) {
      var previousChildren = this.childNodes.slice(0, siblingIndex + 1);
      var nextChildren = this.childNodes.slice(siblingIndex + 1);
      this.childNodes = collection_1.ListWrapper.concat(collection_1.ListWrapper.concat(previousChildren, newChildren), nextChildren);
      for (var i = 0; i < newChildren.length; ++i) {
        var newChild = newChildren[i];
        if (lang_1.isPresent(newChild.parent)) {
          newChild.parent.removeChild(newChild);
        }
        newChild.parent = this;
      }
    }
  };
  DebugElement.prototype.query = function(predicate) {
    var results = this.queryAll(predicate);
    return results.length > 0 ? results[0] : null;
  };
  DebugElement.prototype.queryAll = function(predicate) {
    var matches = [];
    _queryElementChildren(this, predicate, matches);
    return matches;
  };
  DebugElement.prototype.queryAllNodes = function(predicate) {
    var matches = [];
    _queryNodeChildren(this, predicate, matches);
    return matches;
  };
  Object.defineProperty(DebugElement.prototype, "children", {
    get: function() {
      var children = [];
      this.childNodes.forEach(function(node) {
        if (node instanceof DebugElement) {
          children.push(node);
        }
      });
      return children;
    },
    enumerable: true,
    configurable: true
  });
  DebugElement.prototype.triggerEventHandler = function(eventName, eventObj) {
    this.listeners.forEach(function(listener) {
      if (listener.name == eventName) {
        listener.callback(eventObj);
      }
    });
  };
  return DebugElement;
}(DebugNode));
exports.DebugElement = DebugElement;
function asNativeElements(debugEls) {
  return debugEls.map(function(el) {
    return el.nativeElement;
  });
}
exports.asNativeElements = asNativeElements;
function _queryElementChildren(element, predicate, matches) {
  element.childNodes.forEach(function(node) {
    if (node instanceof DebugElement) {
      if (predicate(node)) {
        matches.push(node);
      }
      _queryElementChildren(node, predicate, matches);
    }
  });
}
function _queryNodeChildren(parentNode, predicate, matches) {
  if (parentNode instanceof DebugElement) {
    parentNode.childNodes.forEach(function(node) {
      if (predicate(node)) {
        matches.push(node);
      }
      if (node instanceof DebugElement) {
        _queryNodeChildren(node, predicate, matches);
      }
    });
  }
}
var _nativeNodeToDebugNode = new Map();
function getDebugNode(nativeNode) {
  return _nativeNodeToDebugNode.get(nativeNode);
}
exports.getDebugNode = getDebugNode;
function getAllDebugNodes() {
  return collection_1.MapWrapper.values(_nativeNodeToDebugNode);
}
exports.getAllDebugNodes = getAllDebugNodes;
function indexDebugNode(node) {
  _nativeNodeToDebugNode.set(node.nativeNode, node);
}
exports.indexDebugNode = indexDebugNode;
function removeDebugNodeFromIndex(node) {
  _nativeNodeToDebugNode.delete(node.nativeNode);
}
exports.removeDebugNodeFromIndex = removeDebugNodeFromIndex;
